// Acceso a datos de tiempo real (tracking GPS, alertas de pánico, notificaciones).
// Regla: ningún componente llama supabase.from() directo; usa estas funciones.
// Todas devuelven { data, error } como supabase, salvo donde se indique.
import { supabase } from './client';

// ── GPS / estado del conductor ──────────────────────────────────────────────

export async function getDriverStatus(driverUid) {
  const res = await supabase
    .from('drivers')
    .select('status, is_approved')
    .eq('driver_uid', driverUid)
    .maybeSingle();

  if (!res.error && res.data) {
    if (res.data.is_approved === true && (!res.data.status || res.data.status === 'pending')) {
      res.data.status = 'active';
    }
  }
  return res;
}

export async function setDriverTrackingStatus(driverUid, status) {
  return supabase
    .from('drivers_tracking')
    .update({ status, last_updated: new Date().toISOString() })
    .eq('driver_uid', driverUid);
}

// ── Alertas de pánico ───────────────────────────────────────────────────────

export async function findActiveServiceForPanic(userId, isDriver, statuses) {
  const query = supabase
    .from('services')
    .select('service_id')
    .in('status', statuses)
    .order('created_at', { ascending: false })
    .limit(1);
  if (isDriver) {
    query.eq('driver_uid', userId);
  } else {
    query.eq('user_uid', userId);
  }
  return query.maybeSingle();
}

export async function insertPanicAlert(payload) {
  return supabase.from('panic_alerts').insert(payload).select().single();
}

export async function updatePanicAlertLocation(alertId, lat, lng) {
  return supabase.from('panic_alerts').update({ lat, lng }).eq('id', alertId);
}

// ── Notificaciones ──────────────────────────────────────────────────────────

export async function fetchNotifications(userId, limit = 20) {
  return supabase
    .from('notifications')
    .select('*')
    .eq('user_id', userId)
    .order('created_at', { ascending: false })
    .limit(limit);
}

export async function markNotificationsReadByIds(ids) {
  return supabase.from('notifications').update({ read: true }).in('id', ids);
}

export async function notifyAdmins({ type, title, body, link = null, metadata = {} }) {
  try {
    // RPC SECURITY DEFINER: evita depender de policies de user_roles
    // (la columna 'role' no existe en user_roles; se resuelve por roles.level >= 4)
    const { data: adminIds } = await supabase.rpc('get_admin_user_ids');

    if (adminIds && adminIds.length > 0) {
      const uniqueAdminIds = [...new Set(adminIds.map(r => r.user_id || r))];
      await Promise.all(
        uniqueAdminIds.map(uid =>
          supabase.rpc('create_notification', {
            p_user_id: uid,
            p_type: type || 'admin_alert',
            p_title: title,
            p_body: body,
            p_data: { link, ...metadata },
          })
        )
      );
    }
  } catch (err) {
    console.warn('Error in notifyAdmins:', err);
  }
}

// ── Tracking de conductores ─────────────────────────────────────────────────

export async function getDriverTrackingPosition(driverUid) {
  return supabase
    .from('drivers_tracking')
    .select('lat, lng')
    .eq('driver_uid', driverUid)
    .maybeSingle();
}

export async function upsertDriverTracking(driverId, lat, lng, status) {
  return supabase
    .from('drivers_tracking')
    .upsert({
      driver_uid: driverId,
      lat,
      lng,
      status,
      last_updated: new Date().toISOString(),
    }, { onConflict: 'driver_uid' });
}

export async function updateDriverTrackingStatus(driverId, status) {
  return supabase
    .from('drivers_tracking')
    .update({ status, last_updated: new Date().toISOString() })
    .eq('driver_uid', driverId);
}

export async function fetchDriverHistory(driverId, limit = 100) {
  return supabase
    .from('drivers_tracking_history')
    .select('*')
    .eq('driver_uid', driverId)
    .order('created_at', { ascending: false })
    .limit(limit);
}

export async function fetchOnlineDriversTracking(status, limit = 1000) {
  return supabase
    .from('drivers_tracking')
    .select('*')
    .eq('status', status)
    .order('last_updated', { ascending: false })
    .limit(limit);
}
